// extracted by mini-css-extract-plugin
export var divider = "_dr-7";
export var itemsToggle = "_dr-8";
export var mergeModal = "_dr-1";
export var optionCard = "_dr-4";
export var radioGroup = "_dr-6";
export var radioOption = "_dr-0";
export var selected = "_dr-5";
export var shipmentOptions = "_dr-2";
export var tableOptions = "_dr-3";